import * as React from 'react'
import { ReactElement, useEffect, useRef } from 'react'
import { Textarea as ReactTextarea, TextareaProps } from '@fluentui/react-components'

type Props = TextareaProps & {
    autoAdjustHeight?: boolean
}

const handleKeyDown = e => {
    // Reset field height
    e.style.height = 'inherit'

    // Get the computed styles for the element
    const computed = window.getComputedStyle(e)

    // Calculate the height
    const height =
        parseInt(computed.getPropertyValue('border-top-width'), 10) +
        parseInt(computed.getPropertyValue('padding-top'), 10) +
        e.scrollHeight +
        parseInt(computed.getPropertyValue('padding-bottom'), 10) +
        parseInt(computed.getPropertyValue('border-bottom-width'), 10)

    e.style.height = `${height}px`
}

export default function Textarea(props: Props): ReactElement {
    const textareaRef = useRef(null)

    useEffect(() => {
        if (textareaRef.current) {
            handleKeyDown(textareaRef.current)
        }
    }, [textareaRef])

    return (
        <ReactTextarea
            ref={textareaRef}
            {...props}
            onKeyDown={e => props.autoAdjustHeight && handleKeyDown(e.target)}
            onKeyUp={e => props.autoAdjustHeight && handleKeyDown(e.target)}
        />
    )
}
